module.exports = __webpack_public_path__ + "static/image-02-b@2x-2ecdd75e6c0d3edf925ac4e3ccd13d82.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/case-studies/buzzfeed/image-02-b@2x.jpg
// module id = 330
// module chunks = 3627797113349 20562973939449 33019919093843